// SubCategoryPage.js
// This page is to display each main category's child category
import React from 'react';
import {Box, Divider, Heading, SimpleGrid, Text, VStack} from "@chakra-ui/react";
import Navbar from "./Sections/Navbar";
import {
    ChakraProvider,
    ColorModeScript,
    Flex,
    Grid,
    GridItem,
    HStack,
    Link,
    useToast,
    VisuallyHidden,
} from '@chakra-ui/react'
function SubCategoryPage({ category, subCategory }) {
    // console.log(`/${category.path}/${subCategory.path}`)
    return (
        <ChakraProvider>
        <VStack >
            <Navbar ></Navbar>

            <VStack marginTop ={{base:"33%",md:"23%",xl:"15%","2xl":"12%"}}>
                <Box  w = "100%" >
                    <Text  alignSelf={"start"}  mr={"20px"} fontSize='xl' as ="u" cursor={"pointer"} _hover = {{color:"grey"}} onClick={()=>{window.location.href = `/`}}>Back to home</Text>
                </Box>
                <Heading >{category.title}</Heading>
                <Text margin = "20px" fontSize={"2xl"} >{subCategory.description}</Text>
                <Divider></Divider>
                <SimpleGrid columns={{base:1,md:2,xl:5}} spacing = {2} mt = "20px" mb={ "20px"}  h = "fit-content" maxW={"70vw"}>
                    {subCategory.img_urls.map((url, index) => (
                        <img
                            key={index}
                            src={"/ServiceInfoImg/"+url}
                            alt={subCategory.description}
                            style={{ width: '200px', marginRight: '10px' }}
                        />
                    ))}
                </SimpleGrid>
            </VStack>
        </VStack>
        </ChakraProvider>
    );
}

export default SubCategoryPage;
